var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46416 13.4587C5.46416 8.96718 5.46416 4.49943 5.46416 0C10.2977 0.792154 15.1387 1.59223 20.0021 2.3923C20.0021 2.4636 20.0021 2.53489 20.0021 2.60619C20.0021 6.74123 20.0096 10.8842 20.0021 15.0192C20.0021 16.6907 19.2913 17.9581 17.8697 18.6711C16.463 19.3761 15.0788 19.1939 13.8817 18.1245C12.707 17.0709 12.2655 15.6846 12.677 14.1003C13.0886 12.5081 14.1211 11.5338 15.6624 11.2169C16.3433 11.0743 17.0018 11.1773 17.6452 11.4387C17.8697 11.5338 18.1016 11.6209 18.356 11.7239C18.356 11.6288 18.356 11.5654 18.356 11.4942C18.356 9.60883 18.356 7.71558 18.356 5.83025C18.356 5.6639 18.3186 5.60053 18.1465 5.57676C15.857 5.24406 13.5674 4.89551 11.2779 4.55488C10.0807 4.37269 8.88354 4.19049 7.69387 4.01622C7.63401 4.0083 7.57415 4.0083 7.47688 4.00038C7.47688 4.10336 7.47688 4.19842 7.47688 4.3014C7.47688 8.49189 7.47688 12.6824 7.47688 16.8729C7.47688 17.5383 7.37213 18.172 7.09529 18.7661C6.21238 20.6752 4.10988 21.5149 2.26177 20.6752C-0.117583 19.5979 -0.768537 16.2946 1.0272 14.3301C2.06723 13.1894 3.34669 12.8487 4.79824 13.2527C5.02271 13.324 5.24718 13.3953 5.46416 13.4587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/musicNote.d2bd6a88b0aef9c2eacf9938acef2330.svg";
export { ForwardRef as ReactComponent };